<script>
export default {
    name: 'IconSettings'
}
</script>
<template>
    <svg
        class="base-icon icon-settings"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M35 46v10h-6V46h6zM29 8h6v30h5v4H24v-4h5V8zM19 24v32h-6V24h6zM13 8h6v8h5v4H8v-4h5V8zm38 28v20h-6V36h6zM45 8h6v20h5v4H40v-4h5V8z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
